import type { SetupShippingSummary } from '@/components/setup/experience/lib/setupShippingSummary';
import type { SetupSourcePath } from '@/components/setup/experience/types';

export function buildSetupShippingBadgeLabel(
  shippingSnapshot: SetupShippingSummary | null | undefined,
  fallback: string,
): string {
  if (!shippingSnapshot?.previewRateName) return fallback;
  return shippingSnapshot.previewRateName;
}

export function buildSetupIntegrationSummaryKey(sourcePath: SetupSourcePath | null): string {
  switch (sourcePath) {
    case 'shopify':
      return 'shopify';
    case 'woocommerce':
      return 'woocommerce';
    case 'manual':
    default:
      return 'manual';
  }
}
